import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function PopupLoader(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  return (
    <>
      <MDBModal open={true} staticBackdrop={true} closeOnEsc={false} onClick={(e) => e.stopPropagation()} setOpen={props.onShow} className={props.className == "modal-lg" ? props.className : "modal-sm" ? props.className : "modal-xl"}>
        <MDBModalDialog size={props.size}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{props.title}</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={(e) => props.onClose(e)}
                tabIndex={-1}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {props.content}
            </MDBModalBody>
            {props.footer && (
              <MDBModalFooter>
                {props.footer}
              </MDBModalFooter>
            )}
          </MDBModalContent>

        </MDBModalDialog>
      </MDBModal >
    </>
  );
}
